(function(){
  if(window.__hbwtInit) return; window.__hbwtInit=true;
  var CFG = JSON.parse(document.getElementById('HbwtConfig').textContent);
  /* ilustrace typu sprchy (ruční / pevná hlavice) */
  var INK='fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';
  var WTR='fill="none" stroke="#0f6f7c" stroke-width="1.6" stroke-linecap="round"';
  document.body.insertAdjacentHTML('beforeend','<svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false"><defs>'+
    '<symbol id="hbwt-il-hand2" viewBox="0 0 96 72">'+
      '<g '+INK+'>'+
        '<path d="M14 66c6 0 9-4 11-9s5-9 11-9h3"/>'+
        '<path d="M39 46.5c-1.4 1.4-1 3.6.8 4.3 1.4.6 2.9 0 3.6-1.3l12.4-21-4.4-2.6z"/>'+
        '<ellipse cx="60" cy="19" rx="13" ry="8.5" transform="rotate(-32 60 19)"/>'+
        '<ellipse cx="61.5" cy="21" rx="8.5" ry="4.6" transform="rotate(-32 61.5 21)"/>'+
      '</g>'+
      '<g '+WTR+'><path d="M66 30l4 8M61 32l2.5 9M70.5 27l6 7M65 43l1.5 3M74 37l3 3M59 45l.8 3"/></g>'+
    '</symbol>'+
    '<symbol id="hbwt-il-rain2" viewBox="0 0 96 72">'+
      '<g '+INK+'>'+
        '<path d="M10 4v26"/><rect x="10" y="10" width="4" height="8" rx="1"/>'+
        '<path d="M14 14h31c3 0 5 2 5 5v2"/>'+
        '<rect x="26" y="21" width="48" height="5" rx="2.5"/>'+
      '</g>'+
      '<g '+WTR+' stroke-dasharray="5 5"><path d="M31 31v33M38 34v26M45 31v33M52 34v29M59 31v26M66 34v29M71 31v22"/></g>'+
    '</symbol>'+
  '</defs></svg>');
  var $ = function(s){return document.querySelector(s)};
  var store = {
    get:function(k){try{return localStorage.getItem(k)}catch(e){return null}},
    set:function(k,v){try{localStorage.setItem(k,v)}catch(e){}},
    sget:function(k){try{return sessionStorage.getItem(k)}catch(e){return null}},
    sset:function(k,v){try{sessionStorage.setItem(k,v)}catch(e){}},
    sdel:function(k){try{sessionStorage.removeItem(k)}catch(e){}}
  };
  var ic = function(id){return '<svg class="hbwt-i" aria-hidden="true"><use href="#hbwt-'+id+'"/></svg>'};
  var radio = '<span class="hbwt-radio" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span>';
  var esc = function(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})};

  /* ---------- data ---------- */
  var DATA = null, dataP = null;
  function loadData(){
    if(!dataP){
      dataP = fetch(CFG.dataUrl,{credentials:'omit'}).then(function(r){return r.json()}).then(function(d){DATA=d;return d}).catch(function(){DATA={z:[],p:{}};return DATA});
    }
    return dataP;
  }
  /* DATA.p = řetězec po 10 znacích: PSČ (5) + index obce v DATA.n (3, base36) + index zóny v DATA.z (2, base36)
     DATA.z[i] = [voda z, tvrdost °dH|null, chlór 'nizsi'|'stredni'|'vyssi'|null, dezinfekce, spolehlivost: high|medium|okres|kraj] */
  var PIDX = null;
  function pEntry(psc){
    if(!DATA || typeof DATA.p!=='string') return null;
    if(!PIDX){PIDX={}; for(var j=0;j+10<=DATA.p.length;j+=10) PIDX[DATA.p.substr(j,5)]=j;}
    var j=PIDX[psc]; if(j==null) return null;
    return [parseInt(DATA.p.substr(j+5,3),36), parseInt(DATA.p.substr(j+8,2),36)];
  }
  function lookup(psc){
    var e = pEntry(psc);
    if(!e) return {n:'Vaše obec',s:null,dh:null,cl:null,approx:true,known:false};
    var z = DATA.z[e[1]] || [];
    var approx = z[4]==='okres' || z[4]==='kraj';
    return {n:DATA.n[e[0]],s:z[0],dh:z[1],cl:z[2],d:z[3],c:z[4],approx:approx,known:true};
  }
  var CL = {nizsi:{t:'Nižší',c:'g',p:6,w:30},stredni:{t:'Střední',c:'w',p:14,w:58},vyssi:{t:'Vyšší',c:'b',p:22,w:84}};
  function dhLabel(dh){return dh<7?'měkká':dh<14?'středně tvrdá':dh<21?'tvrdá':'velmi tvrdá'}

  /* ---------- dotazník ---------- */
  var STEPS = [
    {id:'psc'},
    {id:'home',q:'V jakém domě bydlíte?',hint:'Ve starších rozvodech se může do vody uvolňovat železo a těžké kovy.',tiles:true,opts:[
      {v:'novy',ic:'il-new',t:'Novostavba',small:'Nebo nové rozvody po roce 2000'},
      {v:'starsi',ic:'il-old',t:'Starší dům',small:'Panelák, činžák nebo starší rodinný dům'}]},
    {id:'shower',q:'Jakou sprchu doma používáte?',hint:'Podle toho vybereme sprchu, která vám bez úprav sedne.',tiles:true,opts:[
      {v:'hand',ic:'il-hand2',t:'Ruční sprcha',small:'Sprcha na hadici, kterou držíte v ruce'},
      {v:'rain',ic:'il-rain2',t:'Pevná hlavice',small:'Velká hlavice nad hlavou, na zdi nebo stropě'}]},
    {id:'smell',q:'Cítíte ve vodě chlór?',hint:'Pozná se podle lehce chemické vůně, nejvíc u teplé vody.',opts:[
      {v:0,t:'Ne'},{v:1,t:'Občas'},{v:2,t:'Ano, často'}]},
    {id:'skin',q:'Jak se cítí vaše pleť po sprše?',opts:[
      {v:0,t:'Příjemně'},{v:1,t:'Napjatá a suchá'},{v:2,t:'Svědí nebo zčervená'}]},
    {id:'hair',q:'A vaše vlasy?',opts:[
      {v:0,t:'Jsou v pořádku'},{v:1,t:'Bez lesku, krepatí se'},{v:2,t:'Lámou se a třepí'},{v:3,t:'Více mi padají'}]},
    {id:'email'},
    {id:'result'}
  ];
  var QN = STEPS.length-1;
  var S = {i:0,A:{},area:null,email:''};
  var body = $('#HbwtBody');

  function compute(){
    var A=S.A, area=S.area||{};
    var pipes = A.home==='novy'?0:1;
    var clKey = area.cl || (A.smell===2?'vyssi':A.smell===1?'stredni':'nizsi');
    var clEst = !area.cl;
    var s=100;
    s-=CL[clKey].p; s-=[0,8,15][A.smell]||0; s-=[0,12][pipes]||0; s-=[0,10,15][A.skin]||0; s-=[0,10,12,15][A.hair]||0;
    s=Math.max(18,Math.min(96,s));
    var v = s>=75?{t:'Vaše voda může být šetrnější',col:'#0f6f7c',k:'dobra'}:s>=50?{t:'Vaše voda má rezervy',col:'#d18a00',k:'rezervy'}:{t:'Voda zatěžuje vaše vlasy i pleť',col:'#d4462f',k:'zatezuje'};
    var lv = function(n,arr){return arr[n]||arr[0]};
    var metal = pipes?{t:'Možné',c:'w'}:{t:'Nízké',c:'g'};
    var hairI = lv(A.hair,[{t:'Nízký',c:'g'},{t:'Střední',c:'w'},{t:'Vysoký',c:'b'},{t:'Vysoký',c:'b'}]);
    var skinI = lv(A.skin,[{t:'Nízký',c:'g'},{t:'Střední',c:'w'},{t:'Vysoký',c:'b'}]);
    var P = CFG.products, prod = A.shower==='rain'
      ? {p:P.rain, k:'rain-shower-2', why:'Pevná hlavice s filtrem, která zachytí přes 90 % chlóru a nečistot. Namontujete ji místo té stávající.'}
      : {p:P.hand, k:'hand-shower', why:'Ruční sprcha s filtrem, která zachytí přes 90 % chlóru, těžkých kovů a nečistot. Našroubujete ji na stávající hadici.'};
    return {s:s,v:v,cl:clKey,clEst:clEst,metal:metal,hairI:hairI,skinI:skinI,prod:prod,pipes:pipes};
  }
  function money(cents){return Math.round(cents/100).toLocaleString('cs-CZ')+' Kč'}

  function render(){
    var st=STEPS[S.i];
    $('#HbwtStep').textContent = st.id==='result'?'Výsledek':(Math.min(S.i+1,QN)+' z '+QN);
    $('#HbwtProg').style.width = (st.id==='result'?100:Math.round(S.i/QN*100+6))+'%';
    var w=document.createElement('div'); w.className='hbwt-fade';
    w.innerHTML = st.id==='psc'?pscHTML():st.id==='email'?emailHTML():st.id==='result'?resultHTML():optsHTML(st);
    body.innerHTML=''; body.appendChild(w); bind(st);
    var sh=$('.hbwt-sheet'); if(sh) sh.scrollTop=0;
  }
  var backBtn = '<button class="hbwt-back" type="button" data-hbwt-back>'+ic('chev-l')+'Zpět</button>';

  function pscHTML(){
    return '<h2 class="hbwt-q" id="HbwtTitle">Sprchujete se denně. Víte vlastně v čem?</h2>'+
      '<p class="hbwt-hint"><strong class="hbwt-strong">Zadejte PSČ</strong> a během 30 vteřin zjistíte, co obsahuje vaše voda a jak působí na vlasy i pleť.</p>'+
      '<form id="HbwtPscForm" novalidate><div class="hbwt-field">'+
      '<input id="HbwtPsc" inputmode="numeric" autocomplete="postal-code" placeholder="PSČ" maxlength="6" aria-label="PSČ" value="'+esc(S.A.psc||'')+'">'+
      '<button class="hbwt-cta" type="submit">Dál</button></div>'+
      '<div class="hbwt-err" id="HbwtPscErr" hidden>Zadejte pětimístné PSČ, například 130 00.</div></form>'+
      '<div id="HbwtFound"></div>';
  }
  function optsHTML(st){
    var k, html='<h2 class="hbwt-q" id="HbwtTitle">'+st.q+'</h2><p class="hbwt-hint">'+(st.hint||'')+'</p>';
    if(st.tiles){
      html+='<div class="hbwt-tiles">';
      for(k=0;k<st.opts.length;k++){var o=st.opts[k];
        html+='<button type="button" class="hbwt-opt hbwt-tile'+(S.A[st.id+'_k']===k?' is-sel':'')+'" data-k="'+k+'">'+radio+
          '<svg class="hbwt-il" viewBox="0 0 96 72" aria-hidden="true"><use href="#hbwt-'+o.ic+'"/></svg>'+
          '<span class="hbwt-txt">'+o.t+'<small>'+o.small+'</small></span></button>';}
      html+='</div>';
    } else {
      html+='<div class="hbwt-opts">';
      for(k=0;k<st.opts.length;k++){var p=st.opts[k];
        html+='<button type="button" class="hbwt-opt'+(S.A[st.id+'_k']===k?' is-sel':'')+'" data-k="'+k+'"><span class="hbwt-txt">'+p.t+(p.small?'<small>'+p.small+'</small>':'')+'</span>'+radio+'</button>';}
      html+='</div>';
    }
    return html+backBtn;
  }
  function gauge(s,col,size){
    var r=27,c=2*Math.PI*r,off=c*(1-s/100);
    return '<svg width="'+size+'" height="'+size+'" viewBox="0 0 64 64" role="img" aria-label="Skóre '+s+' ze 100" style="flex:none"><circle cx="32" cy="32" r="'+r+'" fill="none" stroke="#f0eff3" stroke-width="4"/><circle cx="32" cy="32" r="'+r+'" fill="none" stroke="'+col+'" stroke-width="4" stroke-linecap="round" stroke-dasharray="'+c.toFixed(1)+'" stroke-dashoffset="'+off.toFixed(1)+'" transform="rotate(-90 32 32)"/><text x="32" y="37.5" text-anchor="middle" font-family="-apple-system,system-ui,sans-serif" font-weight="600" font-size="16" fill="#2e2a39">'+s+'</text></svg>';
  }
  function emailHTML(){
    var r=compute(), A=S.A;
    var bar=function(label,w,g){return '<div class="hbwt-bar">'+label+'<i><b style="width:'+w+'%;background:linear-gradient(90deg,'+g+')"></b></i></div>'};
    return '<h2 class="hbwt-q" id="HbwtTitle">Váš rozbor vody je připravený.</h2>'+
      '<p class="hbwt-hint">Kam vám ho máme poslat?</p>'+
      '<div class="hbwt-teaser" aria-hidden="true"><div class="hbwt-blur">'+
        '<div class="hbwt-thead">'+gauge(r.s,r.v.col,64)+'<div><div class="hbwt-ttitle">'+r.v.t+'</div><div class="hbwt-tsub">Rozbor vody · '+esc(S.area.n)+'</div></div></div>'+
        '<div class="hbwt-bars">'+
          bar('Chlór',CL[r.cl].w,'#f2c14e,#e0743a')+
          bar('Kovy',r.pipes?55:22,'#8fd3c7,#0f8f8a')+
          bar('Vlasy',[20,52,74,88][A.hair]||20,'#c9a7f0,#8a5cd8')+
          bar('Pleť',[20,55,82][A.skin]||20,'#f5a3b5,#d9506f')+
        '</div></div>'+
        '<div class="hbwt-lock"><span>'+ic('lock')+'Zadejte e-mail pro zobrazení</span></div></div>'+
      '<ul class="hbwt-perks">'+
        '<li>'+ic('check')+'<span>Osobní rozbor vody pro '+esc(S.area.n)+'</span></li>'+
        '<li>'+ic('check')+'<span>Tip přímo pro vaše vlasy a pleť</span></li>'+
        '<li>'+ic('check')+'<span><b>Sleva '+CFG.pct+' %</b> na první filtrační sprchu</span></li></ul>'+
      '<form id="HbwtMailForm" novalidate><div class="hbwt-field">'+
        '<input id="HbwtEmail" class="hbwt-email" type="email" inputmode="email" autocomplete="email" placeholder="E-mail" aria-label="E-mail" value="'+esc(S.email)+'"></div>'+
        '<div class="hbwt-err" id="HbwtMailErr" hidden>Zkontrolujte e-mail, chybí v něm @ nebo doména.</div>'+
        '<button class="hbwt-cta hbwt-wide" type="submit">Zobrazit výsledek</button></form>'+
      '<p class="hbwt-tiny">Spolu s rozborem vám budeme posílat tipy a novinky. Z newsletteru se můžete kdykoliv odhlásit.</p>'+
      backBtn;
  }
  function resultHTML(){
    var r=compute(), A=S.A, a=S.area;
    var P=r.prod.p, disc=Math.round(P.price*(100-CFG.pct)/100);
    var h='<div class="hbwt-sent">'+ic('check')+'Rozbor jsme poslali na '+esc(S.email)+'</div>'+
      '<div class="hbwt-gauge">'+gauge(r.s,r.v.col,80)+'<div><div class="hbwt-step">Hebchee skóre vody</div><div class="hbwt-verdict" id="HbwtTitle">'+r.v.t+'</div></div></div>'+
      '<div class="hbwt-rows">'+
        '<div class="hbwt-r"><span>Lokalita</span><span>'+esc(a.n)+'</span></div>'+
        (a.s?'<div class="hbwt-r"><span>'+(a.approx?'Dodavatel v okolí':'Voda z')+'</span><span>'+esc(a.s)+'</span></div>':'')+
        '<div class="hbwt-r"><span>Chlór ve vodě'+(r.clEst?', odhad':'')+'</span><span class="hbwt-lvl '+CL[r.cl].c+'">'+CL[r.cl].t+'</span></div>'+
        '<div class="hbwt-r"><span>Kovy z rozvodů</span><span class="hbwt-lvl '+r.metal.c+'">'+r.metal.t+'</span></div>'+
        '<div class="hbwt-r"><span>Vliv na vlasy</span><span class="hbwt-lvl '+r.hairI.c+'">'+r.hairI.t+'</span></div>'+
        '<div class="hbwt-r"><span>Vliv na pleť</span><span class="hbwt-lvl '+r.skinI.c+'">'+r.skinI.t+'</span></div>'+
        (a.dh!=null?'<div class="hbwt-r"><span>'+(a.approx?'Tvrdost v okolí, orientačně':'Tvrdost, pro informaci')+'</span><span class="hbwt-lvl">'+String(a.dh).replace('.',',')+' °dH, '+dhLabel(a.dh)+'</span></div>':'')+
      '</div>'+
      '<p class="hbwt-note">'+(a.dh!=null?'Tvrdost vody ovlivňuje hlavně vodní kámen. ':'')+'Filtry hebchee se zaměřují na chlór, těžké kovy a nečistoty.</p>'+
      (r.v.k==='dobra'?'<p class="hbwt-note">I dobrá voda je dezinfikovaná chlórem. Ten při každodenním sprchování postupně vysušuje vlasy i pleť. Filtrační sprcha ho zachytí přes 90 %.</p>':'')+
      '<h3 class="hbwt-sub">Tip pro vás</h3><ul class="hbwt-tips"><li>'+ic('drop')+'<span>Sprchujte se o pár stupňů chladněji, chlór se v horké vodě uvolňuje víc.</span></li>';
    h+='</ul><div class="hbwt-reco">'+
      '<div class="hbwt-reco-top"><a class="hbwt-ph" href="'+esc(P.url)+'">'+(P.image?'<img src="'+esc(P.image)+'" alt="'+esc(P.title)+'" width="96" height="96" loading="lazy">':ic('shower'))+'</a><div><span class="hbwt-step">Doporučujeme</span><b>'+esc(P.title)+'</b>'+
      '<span class="hbwt-price"><s>'+money(P.price)+'</s><strong>'+money(disc)+'</strong></span></div></div>'+
      '<span class="hbwt-why">'+r.prod.why+'</span>'+
      '<div class="hbwt-code"><span>Váš slevový kód</span><code>'+CFG.code+'</code></div>'+
      '<button class="hbwt-cta hbwt-wide hbwt-accent" type="button" id="HbwtAtc">Přidat do košíku se slevou</button>'+
      '<a href="'+esc(P.url)+'" class="hbwt-back" style="justify-content:center;margin-top:0">Zobrazit produkt'+ic('chev-r')+'</a>'+
      '</div>'+
      '<p class="hbwt-src">Údaje o vodě vycházejí z veřejných rozborů vodárenských společností'+(DATA&&DATA.updated?', stav '+esc(DATA.updated):'')+'. '+(a.approx?'Pro vaši obec nemáme samostatný rozbor, proto ukazujeme typické hodnoty z okolí.':'Jde o orientační hodnoty pro vaši oblast.')+'</p>';
    return h;
  }

  function tags(){
    var r=compute(), A=S.A;
    return ['test-vody','test-vody-'+new Date().toISOString().slice(0,7),'dum:'+A.home,'psc:'+String(A.psc||'').replace(/\D/g,'').slice(0,3),
      'chlor:'+r.cl,'vlasy:'+['ok','krepate','lame','padaji'][A.hair],'plet:'+['ok','sucha','svedi'][A.skin],
      'skore:'+r.v.k,'sprcha:'+(A.shower==='rain'?'hlavice':'rucni'),'doporuceni:'+r.prod.k].join(', ');
  }

  /* Ochrana Shopify (hCaptcha) se k formuláři připojí až při jeho „focusu“. Náš formulář je skrytý,
     proto ji připojíme sami hned při zobrazení kroku s e-mailem. */
  function bindCaptcha(){
    var inp=document.getElementById('HbwtFormEmail');
    if(inp) inp.dispatchEvent(new FocusEvent('focusin',{bubbles:true}));
  }
  /* Odeslání klasickým formulářem Shopify (stránka se přenačte). Pokud Shopify chce ověření,
     zákazník ho vyřeší na stránce Shopify. Po návratu (?customer_posted=true) výsledek ukážeme znovu. */
  function submitContact(){
    var f=document.getElementById('HbwtForm');
    document.getElementById('HbwtFormEmail').value=S.email;
    document.getElementById('HbwtFormTags').value=tags();
    store.sset('hbwt_pending',JSON.stringify(S));
    f.removeAttribute('target');
    if(f.requestSubmit) f.requestSubmit(); else f.submit();
  }

  function bind(st){
    var back=body.querySelector('[data-hbwt-back]');
    if(back) back.onclick=function(){S.i=Math.max(0,S.i-1);render()};
    if(st.id==='psc'){
      var inp=$('#HbwtPsc'), f=$('#HbwtPscForm'), go=f.querySelector('.hbwt-cta');
      var sync=function(){
        var d=inp.value.replace(/\D/g,'').slice(0,5);
        go.classList.toggle('is-ready',d.length===5);
        if(d.length===5){loadData().then(function(){showFound(d)})} else $('#HbwtFound').innerHTML='';
      };
      inp.addEventListener('input',function(){
        var d=inp.value.replace(/\D/g,'').slice(0,5);
        inp.value=d.length>3?d.slice(0,3)+' '+d.slice(3):d;
        $('#HbwtPscErr').hidden=true; sync();
      });
      f.onsubmit=function(e){
        if(e&&e.preventDefault) e.preventDefault();
        var d=inp.value.replace(/\D/g,'');
        if(d.length!==5){$('#HbwtPscErr').hidden=false;return}
        loadData().then(function(){S.A.psc=d;S.area=lookup(d);S.i++;render()});
      };
      if(S.A.psc){inp.value=S.A.psc.slice(0,3)+' '+S.A.psc.slice(3); sync();}
      setTimeout(function(){inp.focus()},60);
    } else if(st.opts){
      var btns=body.querySelectorAll('.hbwt-opt');
      Array.prototype.forEach.call(btns,function(b){b.onclick=function(){
        var k=+b.getAttribute('data-k'); S.A[st.id]=st.opts[k].v; S.A[st.id+'_k']=k;
        Array.prototype.forEach.call(btns,function(x){x.classList.remove('is-sel')}); b.classList.add('is-sel');
        setTimeout(function(){S.i++;render()},380);
      }});
    } else if(st.id==='email'){
      $('#HbwtMailForm').onsubmit=function(e){
        e.preventDefault();
        var v=$('#HbwtEmail').value.trim();
        if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)){var me=$('#HbwtMailErr');me.textContent='Zkontrolujte e-mail, chybí v něm @ nebo doména.';me.hidden=false;return}
        S.email=v;
        var btn=this.querySelector('button'); btn.disabled=true;
        btn.textContent='Odesílám…';
        submitContact();
        /* pojistka: kdyby se stránka do 15 s neodeslala, tlačítko znovu povolíme */
        setTimeout(function(){btn.disabled=false; btn.textContent='Zobrazit výsledek';},15000);
      };
      bindCaptcha();
      setTimeout(function(){$('#HbwtEmail').focus()},60);
    } else if(st.id==='result'){
      var P=compute().prod.p, atc=$('#HbwtAtc');
      atc.onclick=function(){
        atc.disabled=true;
        var goCart=function(){location.href='/discount/'+encodeURIComponent(CFG.code)+'?redirect=%2Fcart'};
        if(!P.variant){goCart();return}
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:P.variant,quantity:1}]})})
          .then(goCart,goCart);
      };
    }
  }
  function showFound(d){
    var a=lookup(d), el=$('#HbwtFound'); if(!el) return;
    el.innerHTML='<button type="button" class="hbwt-found" id="HbwtFoundGo"><span class="hbwt-pinbox">'+ic('pin')+'</span>'+
      '<span class="hbwt-found-t"><b>'+esc(a.n)+'</b>'+(a.s?'<br><span>'+(a.approx?'V okolí: ':'Voda z: ')+esc(a.s)+'</span>':'')+'</span>'+
      '<span class="hbwt-found-go">Pokračovat'+ic('chev-r')+'</span></button>';
    $('#HbwtFoundGo').onclick=function(){$('#HbwtPscForm').onsubmit()};
  }

  /* ---------- bublina v hlavičce ---------- */
  function addPill(){
    if(!CFG.showPill) return;
    var icons=document.querySelector('.header__icons');
    if(!icons || icons.querySelector('.hbwt-pill')) return;
    var b=document.createElement('button');
    b.type='button'; b.className='hbwt-pill'; b.setAttribute('data-hbwt-open','');
    b.innerHTML='Test vody<span class="hbwt-dot" aria-hidden="true"></span>';
    var anchor=icons.querySelector('.header__search, details-modal');
    icons.insertBefore(b, anchor || icons.firstChild);
  }
  addPill();
  document.addEventListener('shopify:section:load',addPill);

  /* ---------- otevírání / zavírání ---------- */
  var scrim=$('#HbwtScrim'), bubble=$('#HbwtBubble'), lastFocus=null, isOpen=false;
  function open(){
    if(isOpen) return; isOpen=true;
    lastFocus=document.activeElement; loadData();
    scrim.hidden=false; bubble.hidden=true; document.documentElement.classList.add('hbwt-lock-scroll');
    store.set('hbwt_seen',String(Date.now()));
    render();
  }
  function close(){
    isOpen=false; scrim.hidden=true; document.documentElement.classList.remove('hbwt-lock-scroll');
    if(STEPS[S.i].id!=='result' && !store.get('hbwt_done')){bubble.hidden=false; store.sset('hbwt_bubble','1')}
    if(lastFocus&&lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-hbwt-open],a[href$="#test-vody"]');
    if(t){e.preventDefault(); open();}
  });
  $('#HbwtClose').onclick=close;
  scrim.addEventListener('click',function(e){if(e.target===scrim) close()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&isOpen) close()});

  /* návrat po ověření hCaptcha */
  var pending=store.sget('hbwt_pending');
  if(pending){
    store.sdel('hbwt_pending');
    try{S=JSON.parse(pending);}catch(e){}
    if(/customer_posted=true/.test(location.search)){
      store.set('hbwt_done','1');
      try{history.replaceState(null,'',location.pathname)}catch(e){}
      loadData().then(function(){S.i=STEPS.length-1; open();});
    } else if(S && S.email){
      /* odeslání neprošlo (např. neplatný e-mail): vrátíme zákazníka na krok s e-mailem */
      loadData().then(function(){
        S.i=STEPS.map(function(x){return x.id}).indexOf('email'); open();
        var me=$('#HbwtMailErr'); if(me){me.textContent='E-mail se nepodařilo odeslat. Zkontrolujte ho a zkuste to znovu.'; me.hidden=false;}
      });
    }
  } else if(location.hash==='#test-vody'){
    open();
  } else if(store.sget('hbwt_bubble') && !store.get('hbwt_done')){
    bubble.hidden=false;
  }

  /* automatické otevření: po nastaveném čase nebo při odchodu, max. 1× za 7 dní, ne po dokončení */
  var seen=+store.get('hbwt_seen')||0, WEEK=7*864e5;
  if(!CFG.skipAuto && !store.get('hbwt_done') && Date.now()-seen>WEEK){
    var fired=false, fire=function(){if(fired||isOpen) return; fired=true; open();};
    setTimeout(fire,CFG.delay||25000);
    document.addEventListener('mouseout',function(e){if(!e.relatedTarget && e.clientY<=0) fire();});
  }
})();
